import { post } from "./http";
export var trackEvent = function (event) { return post("https://logstash.internal.tkevents.io", event); };
//# sourceMappingURL=analytics.js.map